import {Drawable} from "./Drawable";

export class Tool extends Drawable{

	getCursor() {
		return null;
	}

	drawAfterModel(ctx, pixelWidth) {
	}

	drawBeforeModel(ctx, pixelWidth) {
	}

	/**
	 * @param {MouseEvent} e
	 * @param {Canvas} canvas
	 */
	static normalizeEvent(e, canvas) {
		return this.normalize(e.offsetX, e.offsetY, canvas);
	}

	/**
	 * @param {number} screenX - position in screen coordinates
	 * @param {number} screenY
	 * @param {Canvas} canvas
	 */
	static normalize(screenX, screenY, canvas) {
		const z = canvas.zoom;
		return {
			x : (screenX - canvas.scrollX)/z,
			y : (screenY - canvas.scrollY)/z,
		}
	}

	/**
	 * @param {MouseEvent} e
	 * @param {Canvas} canvas
	 * @return {boolean}
	 */
	mouseDown(e, canvas) {
		return false;
	}

	/**
	 * @param {MouseEvent} e
	 * @param {Canvas} canvas
	 * @return {boolean}
	 */
	mouseUp(e, canvas) {
		return false;
	}

	/**
	 * @param {MouseEvent} e
	 * @param {Canvas} canvas
	 * @return {boolean}
	 */
	mouseMove(e, canvas) {
		return false;
	}
}